import GameObj from '@/app/game/elements/GameObj';
import { TimelineMax } from '@/vendor';

export default class Present extends GameObj
{
    constructor( settings )
    {
        super( settings );

        this.settings = Object.assign({}, settings );
        this.name = 'present' + settings.index;

        this.id = settings.id;

        this.z = settings.z;
        this.pos.x = settings.x;
        this.pos.y = settings.y;

        let texture = PIXI.loader.resources[ 'elem' + this.id ].texture;
        this.sprite = new PIXI.Sprite( texture );

        this.sprite.anchor.set( 0.5 );
        this.sprite.scale.x = settings.scale / 2;
        this.sprite.scale.y = settings.scale / 2;

        this.sprite.width = this.sprite.width * 1.5;
        this.sprite.height = this.sprite.height * 1.5;

        this.colorMatrix = new PIXI.filters.ColorMatrixFilter();
        this.sprite.filters = [ this.colorMatrix ];
        this.colorMatrix.brightness( settings.brightness || 1 );

        // this.sprite.cacheAsBitmap = true;
        this.sprite.x = this.pos.x;
        this.sprite.y = this.pos.y;

        this.sprite.interactive = true;
        // this.sprite.hitArea = new PIXI.Circle( 0, 0, Config.BALL_SIZE / 2 );
        this.sprite.on( 'click', this.onClick.bind( this ) );
        this.sprite.on( 'tap', this.onClick.bind( this ) );

        this.sprite.zIndex = settings.z;
    }

    onClick( e )
    {
        this.eventHub.emit( 'presentSuicide' + this.id, { pos: this.pos });
    }

    beforeDestroy()
    {
        return new Promise( resolve =>
        {
            let tl = new TimelineMax({ onComplete: resolve });
            tl.to( this.sprite, 0.3, { width: 0, height: 0, alpha: 0 }, 0 );
        });
    }

    async destroy()
    {
        this.sprite.interactive = false;

        this.eventHub.emit( 'startPresentAnim', { id: this.id, pos: this.pos, width: this.sprite.width, height: this.sprite.height });
        await this.beforeDestroy();

        this.sprite.parent.removeChild( this.sprite );
    }
}



// WEBPACK FOOTER //
// ./src/app/game/elements/Present.js